<template>
    <div class="chartRow">
        <div class="chartCol">
            <div id="barLeftChart" :style="{width: '96%', height: '360px'}"></div>
        </div>
        <div class="chartCol">
            <div id="barRightChart" :style="{width: '96%', height: '360px'}"></div>
        </div>
    </div>
</template>

<script>
import './westeros.js'
export default {
    data(){
        return{
           
        }
    },
    mounted(){
        this.barLeftChart()
        this.barRightChart()
    },
   
    methods:{
        barLeftChart(){
            // 基于准备好的dom，初始化echarts实例
            let myChart = this.$echarts.init(document.getElementById('barLeftChart'),'westeros')
            // 绘制图表
            myChart.setOption({
                title: {
                    text: '整体表现',
                    left: 'center'
                },
                xAxis: [
                    {
                    type: 'category',
                    data: ['P1', 'P2+', 'P2', 'P2-', 'P3'],
                    axisPointer: {
                        type: 'shadow'
                    }
                    }
                ],
                yAxis: [
                    {
                    type: 'value',
                    min: 0,
                    max: 25,
                    interval: 5,
                    axisLabel: {
                        formatter: '{value}'
                    }
                    },
                    {
                    type: 'value',
                    min: 0,
                    max: 80,
                    interval: 20,
                    axisLabel: {
                        formatter: '{value} %'
                    },
                    }
                ],
                series: [
                    {
                    name: 'Evaporation',
                    type: 'bar',
                    barWidth: 30,
                    data: [7,3,5,2,22]
                    },
                    {
                    name: 'Temperature',
                    type: 'line',
                    data: [7,3,5,2,22]
                    }
                ]
            });
            window.addEventListener("resize",function(){
                myChart.resize();
            });
        },
        barRightChart(){
            // 基于准备好的dom，初始化echarts实例
            let myChart = this.$echarts.init(document.getElementById('barRightChart'),'westeros')
            // 绘制图表
            myChart.setOption({
                title: {
                    text: '目标分类',
                    left: 'center'
                },
                xAxis: [
                    {
                    type: 'category',
                    data: ['T1', 'T2+', 'T2', 'T2-', 'T3'],
                    axisPointer: {
                        type: 'shadow'
                    }
                    }
                ],
                yAxis: [
                    {
                    type: 'value',
                    min: 0,
                    max: 10,
                    interval: 2,
                    axisLabel: {
                        formatter: '{value}'
                    }
                    },
                    {
                    type: 'value',
                    min: 0,
                    max: 50,
                    interval: 10,
                    axisLabel: {
                        formatter: '{value} %'
                    },
                    }
                ],
                series: [
                    {
                    name: 'Evaporation',
                    type: 'bar',
                    barWidth: 30,
                    data: [9,3,2,0,4]
                    },
                    {
                    name: 'Temperature',
                    type: 'line',
                    data:[9,3,2,0,4]
                    }
                ]
            });
             window.addEventListener("resize",function(){
                myChart.resize();
            });
        }
    }
}
</script>

<style scoped>
.ivu-input-prefix i, .ivu-input-suffix i {
    line-height: 28px !important;
}
.chartRow {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
}
.chartCol {
    width: 50%;
    padding: 20px;
    box-sizing: border-box;
    border:1px solid #dcdee2
}
.chartCol:nth-child(odd) {
    border-right:0px solid #dcdee2
}

</style>


// WEBPACK FOOTER //
// src/components/bipage/components/BarChart.vue